import React, { useEffect } from "react";
import styles from "./BridgingLoanBlog.module.scss";
import CallAdviser from "../../components/CallAdviser";
import NewsContainer from "../../components/NewsContainer";
import TestimonialsContainer from "../../components/TestimonialsContainer";
import Footer from "../../components/Footer";
import CompareContainerB7 from "../../components/CompareContainer/CompareContainerB7";
import MatchingMortgagesB7 from "../../components/MatchingMortgages/MatchingMortgagesB7";
import LoanApplication from "../../components/LoanApplication/LoanApplication";
import HeroSection from "../../components/HeroSection/HeroSection";
const BridgingLoanBlog7 = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className={styles.bridgingLoanBlog}>
      <HeroSection title="Bridging Loans" />
      <CompareContainerB7 title="Bridging Loans" />
      <CallAdviser title="Bridging Loans" />
      <MatchingMortgagesB7 title="Bridging Loans" />
      <NewsContainer title="Bridging Loans" />
      <LoanApplication title="Bridging Loans" />
      <TestimonialsContainer title="Bridging Loans" />
      <Footer title="Bridging Loans" />
    </div>
  );
};

export default BridgingLoanBlog7;
